// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

import { isWindows } from "./_os.ts";
import { fromFileUrl as posixFromFileUrl } from "./posix/from_file_url.ts";
import { fromFileUrl as windowsFromFileUrl } from "./windows/from_file_url.ts";

/**
 * Converts a file URL to a path string.
 *
 * @example Usage
 * ```ts
 * import { fromFileUrl } from "@std/path/from-file-url";
 * import { assertEquals } from "@std/assert";
 *
 * if (Deno.build.os === "windows") {
 *   assertEquals(fromFileUrl("file:///home/foo"), "\\home\\foo");
 *   assertEquals(fromFileUrl("file:///C:/Users/foo"), "C:\\Users\\foo");
 *   assertEquals(fromFileUrl("file://localhost/home/foo"), "\\home\\foo");
 * } else {
 *   assertEquals(fromFileUrl("file:///home/foo"), "/home/foo");
 * }
 * ```
 *
 * @param url The file URL to convert to a path.
 * @returns The path string.
 */
export function fromFileUrl(url: string | URL): string {
  return isWindows ? windowsFromFileUrl(url) : posixFromFileUrl(url);
}

// denoCacheMetadata={"headers":{"x-robots-tag":"noindex","cross-origin-resource-policy":"cross-origin","x-goog-stored-content-encoding":"identity","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-goog-stored-content-length":"1050","content-length":"1050","accept-ranges":"bytes","age":"2328","content-type":"text/typescript","x-guploader-uploadid":"AHmUCY1w34qTW0n7IR9PAZKccbpAT1X-nQz__PGg8YDr3fj57YJCApuEf2oG_LtO6XDW7LzNBD0","x-goog-hash":"crc32c=IM0RBQ==,md5=Ha+Lc6fQa7mDH9JJ5RgtaQ==","server":"UploadServer","x-goog-generation":"1730457483044919","last-modified":"Fri, 01 Nov 2024 10:38:03 GMT","x-jsr-cache-id":"IAD","x-content-type-options":"nosniff","via":"1.1 google","access-control-expose-headers":"*","etag":"\"1daf8b73a7d06bb9831fd249e5182d69\"","x-goog-metageneration":"1","cache-control":"public, max-age=31536000, immutable","x-jsr-cache-status":"hit","date":"Fri, 08 Nov 2024 09:31:12 GMT","x-goog-storage-class":"STANDARD","expires":"Sat, 08 Nov 2025 09:31:12 GMT","access-control-allow-origin":"*"},"url":"https://jsr.io/@std/path/1.0.8/from_file_url.ts","time":1731060600}